import request from '@/utils/request'

// 查询销售合同列表
export function listXsht(query) {
  return request({
    url: '/xm/xsht/list',
    method: 'get',
    params: query
  })
}

// 查询销售合同详细
export function getXsht(id) {
  return request({
    url: '/xm/xsht/' + id,
    method: 'get'
  })
}

// 查询销售合同详细
export function sqshXsht(id) {
  return request({
    url: '/xm/xsht/sqsh/' + id,
    method: 'get'
  })
}

export function kylistXsht(query){
  return request({
    url: '/xm/xsht/kylist',
    method: 'get',
    params: query
  })
}

export function shlcXsht(data){
  return request({
    url: '/xm/xsht/shlc',
    method: 'post',
    data: data
  })
}

// 新增销售合同
export function addXsht(data) {
  return request({
    url: '/xm/xsht',
    method: 'post',
    data: data
  })
}

export function xgjdXsht(data) {
  return request({
    url: '/xm/xsht/xgjd',
    method: 'post',
    data: data
  })
}

export function fqXsht(data) {
  return request({
    url: '/xm/xsht/fqht',
    method: 'post',
    data: data
  })
}
// 修改销售合同
export function updateXsht(data) {
  return request({
    url: '/xm/xsht',
    method: 'put',
    data: data
  })
}
export function bclrXsht(data) {
  return request({
    url: '/xm/xsht/bclr',
    method: 'put',
    data: data
  })
}
// 删除销售合同
export function delXsht(id) {
  return request({
    url: '/xm/xsht/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/xm/xsht.js